import { gql, useQuery } from "@apollo/client";
import { getCookies } from '@edx/frontend-platform/i18n/lib';
import { getConfig } from "@edx/frontend-platform";

const GET_ORG_ID = gql`
    query getOrgId($orgName: Text) {
        organisations(where: { name: { _eq: $orgName } }) {
            name
            id
            _Organisations {
              name
            }
        }
    }   
`;

function useOrgId() {
  const orgName = getCookies().get("orgName");
  const { data } = useQuery(GET_ORG_ID,
    {
      variables: {
        orgName: orgName,
      },
      context: {
        headers: {
          'x-hasura-role': 'learner',
        },
      }
    }
  );
  return data?.organisations[0]?.id;
}

const GET_ORGANIZATIONS = gql`
    query getOrgs {
        organisations {
            name
            id
            _Organisations {
              name
            }
        }
    }   
`;

function useOrganizations() {
  const { data, loading, error, refetch } = useQuery(GET_ORGANIZATIONS,
    {
      context: {
        headers: {
          'x-hasura-role': 'learner',
        },
      }
    },
  );
  return { data: data?.organisations, loading, error, refetch };
}

function useOrgLogos() {
  const orgName = getCookies().get('orgName');
  const LMS_BASE_URL = getConfig().LMS_BASE_URL;
  const MINIO_BASE_URL = getConfig().MINIO_BASE_URL;

  let logo = LMS_BASE_URL + `/media/organisation-logos/${orgName ? orgName + '/' : ''}logo.png`;
  let logoTrademark = LMS_BASE_URL + `/media/organisation-logos/${orgName ? orgName + '/' : ''}logo-trademark.png`
  let logoFavicon = LMS_BASE_URL + `/media/organisation-logos/${orgName ? orgName + '/' : ''}favicon.ico`
  let logoDark = LMS_BASE_URL + `/media/organisation-logos/${orgName ? orgName + '/' : ''}dark-logo.png`
  let logoDarkTrademark = LMS_BASE_URL + `/media/organisation-logos/${orgName ? orgName + '/' : ''}dark-logo-trademark.png`

  if (MINIO_BASE_URL) {
    logo = MINIO_BASE_URL + `/openedx/openedx/media/organisation-logos/${orgName ? orgName + '/' : ''}logo.png`
    logoTrademark = MINIO_BASE_URL + `/openedx/openedx/media/organisation-logos/${orgName ? orgName + '/' : ''}logo-trademark.png`
    logoFavicon = MINIO_BASE_URL + `/openedx/openedx/media/organisation-logos/${orgName ? orgName + '/' : ''}favicon.ico`
    logoDark = MINIO_BASE_URL + `/openedx/openedx/media/organisation-logos/${orgName ? orgName + '/' : ''}dark-logo.png`
    logoDarkTrademark = MINIO_BASE_URL + `/openedx/openedx/media/organisation-logos/${orgName ? orgName + '/' : ''}dark-logo-trademark.png`
  }

  return { logo, logoTrademark, logoFavicon, logoDark, logoDarkTrademark };
}

export { useOrganizations, useOrgId, useOrgLogos };